import { createAction, props } from '@ngrx/store';

export const selectSupportTab = createAction('SELECT_SUPPORT_TAB', props<{ index: number }>());
export const selectScenariosTab = createAction('SELECT_SCENARIOS_TAB', props<{ index: number }>());
export const selectScenariosStep = createAction('SELECT_SCENARIOS_STEP', props<{ index: number }>());
export const selectPermissionsTab = createAction('SELECT_PERMISSIONS_TAB', props<{ index: number }>());
export const selectDeviceTab = createAction('SELECT_DEVICE_TAB', props<{ index: number }>());
